module.exports = __webpack_public_path__ + "img/user-icon.0d9d96af.svg";